import exodusInstance from 'lib/api/instances/exodus';
import { API_EXODUS_URL } from 'constants/api';
import { AcceptanceLanguageEnum } from 'global/Securities/types/termsAndCondition';

const requestDefault = exodusInstance.defaultInstance;
const requestNoAlert = exodusInstance.noAlert;
const requestWithLanguageNoAlert = exodusInstance.withLanguageInstance(
  AcceptanceLanguageEnum.ENGLISH,
);

const PATH_LOGIN = `${API_EXODUS_URL}/user/v2/password`;
const PATH_NON_LOGIN = `${API_EXODUS_URL}/user/non-login/v2/password`;

/// -------------/ CHANGE PASSWORD---------- /////////
export const requestChangePasswordToken = (password: string) =>
  requestDefault.post(`${API_EXODUS_URL}/user/v2/setting/token`, {
    password,
    type: 'CHANGE_TOKEN_TYPE_PASSWORD',
    req_type: 'CHANGE_TOKEN_REQ_TYPE_EDIT',
  });

export const requestChangePasswordNew = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) => requestNoAlert.post(`${PATH_LOGIN}/change`, { token, password });

export const requestChangePasswordConfirm = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) => requestNoAlert.post(`${PATH_LOGIN}/change/confirm`, { token, password });

export const requestChangePasswordOTP = ({
  channel,
  token,
}: {
  channel: string;
  token: string;
}) =>
  requestWithLanguageNoAlert.post(`${PATH_LOGIN}/change/otp`, {
    channel,
    token,
  });

export const requestChangePasswordOTPVerify = ({
  token,
  otp,
}: {
  token: string;
  otp: string;
}) =>
  requestWithLanguageNoAlert.post(`${PATH_LOGIN}/change/otp/verify`, {
    token,
    otp,
  });

/// -------------/ ---------- /////////

/// -------------/ FORGOT PASSWORD LOGIN---------- /////////

export const requestForgotPasswordLoginNew = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) =>
  requestNoAlert.post(`${PATH_LOGIN}/forgot/new`, {
    token,
    password,
  });

export const requestForgotPasswordLoginConfirm = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) =>
  requestNoAlert.post(`${PATH_LOGIN}/forgot/confirm`, {
    token,
    password,
  });

export const requestForgotPasswordLoginOTP = (channel: string) =>
  requestWithLanguageNoAlert.post(`${PATH_LOGIN}/forgot/otp`, { channel });

export const requestForgotPasswordLoginOTPVerify = ({
  token,
  otp,
}: {
  token: string;
  otp: string;
}) =>
  requestWithLanguageNoAlert.post(`${PATH_LOGIN}/forgot/otp/verify`, {
    token,
    otp,
  });
/// -------------/ ---------- /////////

/// -------------/ FORGOT PASSWORD NON LOGIN---------- /////////

export const requestForgotPasswordNonLoginNew = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) =>
  requestNoAlert.post(`${PATH_NON_LOGIN}/forgot/new`, {
    token,
    password,
  });

export const requestForgotPasswordNonLoginConfirm = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) =>
  requestNoAlert.post(`${PATH_NON_LOGIN}/forgot/confirm`, {
    token,
    password,
  });

export const requestForgotPasswordNonLoginOTP = (email: string) =>
  requestWithLanguageNoAlert.post(`${PATH_NON_LOGIN}/forgot/otp`, { email });

export const requestForgotPasswordNonLoginOTPVerify = ({
  token,
  otp,
}: {
  token: string;
  otp: string;
}) =>
  requestWithLanguageNoAlert.post(`${PATH_NON_LOGIN}/forgot/otp/verify`, {
    token,
    otp,
  });
/// -------------/ ---------- /////////
